export default {
  networkError: 'خطا در دریافت اطلاعات',
  tryAgain: 'دوباره تلاش کن',
  footerNote: '',
  ImContributor: 'من هم به پویش می‌پیوندم',
  fullName: 'نام و نام خانوادگی:',
  chooseFile: 'عکس خود را انتخاب کنید',
  contributionText:
    'به کمپین "نه به تصادف" میپیوندم. با آرزوی اینکه لبخند هایمان در کنار عزیزانمان همیشگی باشد.',
  me: 'من',
  share: 'اشتراک گذاری',
  download: 'دانلود',
  copyToClipboard: 'لینک اشتراک گذاری کپی شد.',
  getCampaignMessage2: 'تو هم بپیوند، سفر به سلامت!',
  promoMessage:
    'هر سال، ۲۰ هزار نفر از ما، برای همیشه از میانمان می‌روند!\n' +
    '۲۰ هزار زندگیِ ناتمام و ۱۰۰ هزار حسرتِ بی پایان در دل خانواده‌ها.\n' +
    '\n' +
    '۸۰۰ هزار نفر مجروح و معلول می‌شوند!\n' +
    '۸ برابرِ شور و هیجان ورزشگاه آزادی، آن هم در آن روز‌های شلوغِ بازی‌های مهم.\n' +
    '\n' +
    'خسارت ناشی از تصادفات ۷ درصد تولید ناخالص ملی است. \n' +
    '۱.۷۵ برابر کل بودجه سلامت!\n' +
    '\n' +
    'پویش ملی نه به تصادف برای همه‌ی ماست.\n' +
    'برای آنکه نوروز، جشن زندگی باشد، نه عزا.\n' +
    'برای آنکه از ما کسی کم نشود.\n' +
    '\n' +
    'بیایید با هم جلوی تصادف را بگیریم…\n' +
    '#نه‌ـبه‌ـتصادف!',
  shareToPublic: 'اشتراک گذاری در سامانه ملی پویش ~~',
  imageSent: 'اشتراک گذاری با موفقیت انجام شد',
  alreadySent: 'شما قبلا به پویش پیوسته اید',
  needHelp: 'به کمک نیاز دارم',

  getCampaignMessage: (name: string) => {
    return `بیشتر مواقع تصادف اتفاق نیست، انتخاب است.
    
من، ${name}،
 انتخاب می‌کنم ایمن رانندگی کنم و به پویش #نه_به_تصادف می‌پیوندم.`;
  },
};
